
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import Head from "next/head"

import SEO from "@/meta/SEO"
import Default from "@/templates/Default"
import ForBrandsPage from "@/views/for-brands/ForBrands"

function ForBrands() {
  return (
    <>
      <Head>
        <title>Dla marek | fansi.pl</title>
        <SEO description="fansi to nowe, atrakcyjne możliwości promocji Twojej marki. Skorzystaj z możliwości jakie daje influencer marketing i dotrzyj do nowych Klientów dzięki popularnym Twórcom internetowym." />
      </Head>
      <ForBrandsPage />
    </>
  )
}

ForBrands.Layout = Default

export default ForBrands


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/for-brands',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  